import { BaseApi } from '.';

export const SolarIrImageApi = {
  getSolarIrImage,
  getThermalImageAltitudes
};

function getSolarIrImage(imageId){
  return BaseApi.get(`/solarThermalImages/${imageId}`);
}

function getThermalImageAltitudes(reportId, axiosConfig){
  return BaseApi.get(`/solar-thermal-images/reportId/${reportId}/altitudes`, axiosConfig);
}
